(() => {
// Teancul de cartonașe din secțiunea quiz: primele 3 întrebări din test.
// La alegerea unui răspuns, cartonașul pleacă și vine următorul; după al treilea, „Continuă testul”
// deschide quizul cu răspunsurile deja bifate (?fe_q=use:daily,placement:external,care:reusable).
// Fără JS, fiecare răspuns e un link direct spre quiz. Custom element, deci editorul curăță listener-ele.
if (customElements.get('fe-v8-quiz-deck')) return;
const LEAVE = 420; // ms, durata plecării cartonașului (fev8-qd-out)
const PICK = 300;  // ms cât rămâne vizibilă floarea pe răspunsul ales

customElements.define('fe-v8-quiz-deck', class extends HTMLElement {
  connectedCallback() {
    this.cards = [...this.querySelectorAll('[data-qd-step]')];
    if (!this.cards.length) return;
    this.url = this.dataset.quizUrl || '';
    this.answers = {};
    this.step = 0;
    this.busy = false;
    this.timers = [];
    this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.events = new AbortController();
    this.cards.forEach((card) => { card.hidden = false; });
    this.classList.add('is-ready');
    this.show(0, false);
    this.addEventListener('click', (e) => {
      const opt = e.target.closest('[data-qd-a]');
      if (opt && this.contains(opt)) {
        e.preventDefault();
        if (!this.busy) this.pick(opt);
        return;
      }
      if (e.target.closest('[data-qd-restart]')) this.restart();
    }, { signal: this.events.signal });
  }

  later(fn, ms) { this.timers.push(setTimeout(fn, this.reduced.matches ? 0 : ms)); }

  href() {
    const pairs = Object.entries(this.answers).map(([q, a]) => q + ':' + a).join(',');
    return this.url + (pairs ? '?fe_q=' + pairs : '') + '#quiz';
  }

  syncLinks() {
    const href = this.href();
    this.querySelectorAll('[data-qd-go]').forEach((a) => { a.href = href; });
    const main = this.closest('[data-fe-v8="quiz"]')?.querySelector('[data-qd-main]');
    if (main) main.href = href;
  }

  pick(opt) {
    const card = opt.closest('[data-qd-q]');
    this.answers[card.dataset.qdQ] = opt.dataset.qdA;
    card.querySelectorAll('[data-qd-a]').forEach((a) => {
      a.classList.toggle('is-picked', a === opt);
      if (a === opt) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
    });
    this.syncLinks();
    this.busy = true;
    this.later(() => { this.busy = false; this.go(this.step + 1); }, PICK);
  }

  restart() {
    this.answers = {};
    this.querySelectorAll('.is-picked').forEach((a) => { a.classList.remove('is-picked'); a.removeAttribute('aria-current'); });
    this.syncLinks();
    this.go(0);
  }

  go(n) {
    const leaving = this.cards[this.step];
    if (n === this.step || !this.cards[n]) return;
    if (!this.reduced.matches && leaving) {
      leaving.classList.add('is-leaving');
      this.later(() => leaving.classList.remove('is-leaving'), LEAVE);
    }
    this.show(n, true);
  }

  show(n, focus) {
    this.step = n;
    this.dataset.step = String(n);
    this.cards.forEach((card, i) => {
      const on = i === n;
      card.classList.toggle('is-active', on);
      card.inert = !on;
      if (on && focus) {
        card.classList.remove('is-entering');
        void card.offsetWidth;
        card.classList.add('is-entering');
      }
    });
    if (focus) this.cards[n].querySelector('.fev8-qd__q')?.focus({ preventScroll: true });
  }

  disconnectedCallback() {
    this.timers?.forEach(clearTimeout);
    this.events?.abort();
  }
});
})();
